module.exports = __webpack_public_path__ + "img/klava.d7f26b74.png";